import React, { Component, Fragment } from 'react';

import logo from '../../assets/logo.svg';
import NavButton from '../NavButton/NavButton';

import AppStore from '../../lib/flux/AppStore';
import AppActions from '../../lib/flux/AppActions';
import AppActionTypes from '../../lib/flux/AppActionTypes';
import NAV from '../../lib/navigation';

import x from '../../assets/icon-x-wht.svg';
import menu from '../../assets/menu_blk.svg';
import xBlack from '../../assets/icon-x-blk.svg';
import fb from '../../assets/icon-facebook.svg';
import ig from '../../assets/icon-instagram.svg';
import tw from '../../assets/icon-twitter.svg';

import './Header.scss'

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: AppStore.getHeader().hidden,
            collapsed: AppStore.getHeader().collapsed,
            expanded: false
        }
    }

    componentDidMount() {
        AppStore.on(AppActionTypes.HEADER, this._handleStoreHeaderChange);
        AppStore.on(AppActionTypes.NAVIGATION, this._handleNavigationChange);
        window.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        AppStore.removeListener(AppActionTypes.HEADER, this._handleStoreHeaderChange);
        AppStore.removeListener(AppActionTypes.NAVIGATION, this._handleNavigationChange);
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    componentDidUpdate(prevProps, prevState) {
        const { hidden } = this.state;
        if (hidden !== prevState.hidden) {
            // console.log('Ian, animate header in here');
        }
    }

    _handleNavigationChange = () => {
        this.setState({ expanded: false });
    }

    _handleStoreHeaderChange = ({ hidden, collapsed, speaker }) => {
        // console.log('_handleStoreHeaderChange', { hidden, collapsed, speaker });
        this.setState({ hidden, collapsed, speaker });
    }

    showExpanded = () => {
        return (
            <Fragment>
                <NavButton label={'Theme'} onClick={() => { AppActions.navigation({ location: NAV.THEME }) }} />
                <NavButton label={'Lineup'} onClick={() => { AppActions.navigation({ location: NAV.LINEUP }) }} />
                <NavButton label={'Ideas Booth'} onClick={() => { AppActions.navigation({ location: NAV.IDEAS }) }} />
                <NavButton label={'Partners'} onClick={() => { AppActions.navigation({ location: NAV.PARTNERS }) }} />
                <NavButton label={'Info'} onClick={() => { AppActions.navigation({ location: NAV.INFO }) }} />
                <NavButton label={'Tickets'} secondary onClick={() => { AppActions.navigation({ location: NAV.TICKETS }) }} />
            </Fragment>
        )
    }

    showCollapsed = () => {
        return (
            <Fragment>
                <div className={'header-date'}>April 27, 2019</div>
                <NavButton className="floating" label={'Buy Tickets'} />
                <NavButton className="clear" icon="menu" onClick={() => { this.setState({ collapsed: false }) }} />
            </Fragment>
        )
    }

    handleKeyDown = (e) => {
        //e.preventDefault();
        const { speaker, hidden } = this.state;
        if (speaker && !hidden) {
            e = e || window.event;
            switch (e.keyCode) {
                case 37:
                    // left   
                    this.speakerPrevious();
                    break;
                // case 38:
                //     // up    
                //     break;
                case 39:
                    // right
                    this.speakerNext();
                    break;
                // case 40:
                //     // down
                //     this.speakerClose();
                //     break;
                default:
                    break;
            }
        }
    }

    speakerNext = () => {
        // console.log('Header.js speakerNext()');
        AppActions.speaker({ speaker: null, move: +1 }, () => {
            AppActions.header({ hidden: true })
        });
    }

    speakerPrevious = () => {
        // console.log('Header.js speakerPrevious()');
        AppActions.speaker({ speaker: null, move: -1 }, () => {
            AppActions.header({ hidden: true })
        });
    }

    speakerClose = () => {
        // console.log('Header.js speakerClose()');
        AppActions.speaker({ speaker: null, move: null }, () => {
            AppActions.header({ speaker: false });
        });
    }

    showSpeader = () => {
        return (
            <Fragment>
                <div id={'header'} className={`Header header-container speaker`}>
                    <div className={'header-left'}>
                        <img src={x} alt={'x'} className={'header-close'} onClick={this.speakerClose}></img>
                    </div>
                    <div className={'header-right'}>
                        <div className={'header-link'} onClick={this.speakerPrevious}>{'Previous'}</div>
                        <div className={'header-link'} onClick={this.speakerNext}>{'Next'}</div>
                    </div>
                </div>
            </Fragment >
        )
    }

    render() {
        const { hidden, collapsed, speaker, expanded } = this.state;

        if (speaker && !hidden) {
            return this.showSpeader();
        }

        let nav = collapsed ? this.showCollapsed : this.showExpanded;

        return (
            <Fragment>
                <div id={'header'} className={`Header ${hidden ? 'hidden' : collapsed ? '' : 'expanded'} desktop`}>
                    <div className={'header-left'}>
                        <img className={'header-logo'} src={logo} alt="logo" onClick={() => { AppActions.navigation({ location: NAV.INTRO }) }} />
                    </div>
                    <div className={'header-right'}>
                        {(nav())}
                    </div>
                </div>
                <div className={`Header ${hidden ? 'hidden' : ''} mobile`}>
                    {!expanded && (
                        <div className={`collapsed`}>
                            <img className={'header-logo'} src={logo} alt="logo" onClick={() => { AppActions.navigation({ location: NAV.INTRO }) }} />
                            <img className={'menu'} alt={'|||'} src={menu} onClick={() => { this.setState({ expanded: true }) }}></img>
                        </div>
                    )}
                    {expanded && (
                        <div className={`expanded`}>
                            <img src={xBlack} alt={'x'} className={`x`} onClick={() => { this.setState({ expanded: false }) }}></img>
                            <div className={'button-container'}>
                                {(nav())}
                            </div>
                            <div className={'social-container'}>
                                <a href={'https://www.facebook.com/TEDxPortland/'}>
                                    <img className={'social-icon'} src={fb}></img>
                                </a>
                                <a href={'https://www.instagram.com/tedxportland/'}>
                                    <img className={'social-icon'} src={ig}></img>
                                </a>
                                <a href={'https://twitter.com/TEDxPortland/'}>
                                    <img className={'social-icon'} src={tw}></img>
                                </a>

                            </div>
                        </div>
                    )}

                </div>
            </Fragment >
        );
    }
}

export default Header;